
/**
 * ProductBar
 *
 * @class ProductBar
 * @extends {HTMLElement}
 */
if (!customElements.get('product-bar')) {
  customElements.define(
    'product-bar',
    class ProductBar extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        this.mainBuyButtons = document.querySelector('.product product-form .product-form__buttons')
        this.previousY = this.mainBuyButtons.getBoundingClientRect().top

        this.observer = new IntersectionObserver(
          ([entry]) => {
            const isVisibleClass = 'is-visible'
            const isButtonsAboveClass = 'is-buttons-above'
            const isButtonsBelowClass = 'is-buttons-below'

            if (!entry.isIntersecting) {
              this.classList.add(isVisibleClass);
            } else {
              this.classList.remove(isVisibleClass);
            }

            const currentY = entry.boundingClientRect.top

            if (currentY < this.previousY) {
              this.classList.add(isButtonsAboveClass)
              this.classList.remove(isButtonsBelowClass)
            } else {
              this.classList.add(isButtonsBelowClass)
              this.classList.remove(isButtonsAboveClass)
            }
            this.previousY = currentY
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 1.0,
          }
        );
        this.observer.observe(this.mainBuyButtons);
      }
      disconnectedCallback() {
        if (this.observer && this.mainBuyButtons)
          this.observer.unobserve(this.mainBuyButtons);
      }
    }
  )
}
